import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import FinanceStatementProgress from "./FinanceStatementProgress";
import IncomeStatementProgress from "./IncomeStatementProgress";
import ProjectsReport from "./ProjectsReport";
import KpiReport from "./KpiReport";
import { reportCPTabs } from "../../../utils/properties";
import { checkRoles } from "../../../utils/utilities";
import { get } from "lodash";

const ReportCP = () => {
  const { t } = useTranslation();
  const mappingKeyReports = {
    financeStatementProgress: <FinanceStatementProgress />,
    incomeStatementProgress: <IncomeStatementProgress />,
    projectsReport: <ProjectsReport />,
    kpiReport: <KpiReport />,
  };
  const userRoles = useSelector((state) => get(state.userInfoDuck, "userInfo.roles", []));
  const reportCPTabsFiltered = [];
  reportCPTabs.forEach((r) => {
    if (checkRoles(userRoles, r.roles)) {
      reportCPTabsFiltered.push({
        label: t(`reportCP.${r.name}`),
        key: r.name,
        children: mappingKeyReports[r.component],
      });
    }
  });
  return <Tabs className="PFtabs" defaultActiveKey={0} items={reportCPTabsFiltered} />;
};

export default ReportCP;
